import React from "react";
import ReactGA from 'react-ga4';

import { blue300 } from "../../../uiKit/assets/colors/colors";
import { setTabType } from "../../../redux/state/communitySlice";
import { useDispatch } from "react-redux";
import { setDonationFormOpen } from "../../../redux/state/donationSlice";

const NoCampaigns = ({ title }) => {

    const dispatch = useDispatch();

    const navigateToDonateToCommunityBalance = () => {
        ReactGA.event('donate_to_our_balance_start')
        dispatch(setTabType(4));
        dispatch(setDonationFormOpen(true))
    }

    return (
        <div>
            <span
                style={{
                    fontSize: '16px',
                    lineHeight: '24px',
                    fontWeight: 400,
                    marginRight: '5px'
                }}
            >
                {`We don't have any ${title} campaigns currently, but you can support community by donating to`}
            </span>
            <span
                style={{
                    fontSize: '16px',
                    fontWeight: 600,
                    lineHeight: '24px',
                    cursor: 'pointer',
                    color: blue300
                }}
                onClick={navigateToDonateToCommunityBalance}
            >
                community balance
            </span>
        </div>
    )
}

export default NoCampaigns;